import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse, } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { map, catchError, switchMap, finalize, filter, take } from 'rxjs/operators';
// import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    isRefreshingToken: boolean;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(
        private authService: AuthService,
        private loadingService: NgxSpinnerService
    ) {
        this.isRefreshingToken = false;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available

        console.log('[Interceptor called]');

        return next.handle(this.addToken(request, this.authService.getAuthToken())).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // do stuff with response if you want
                    return event;
                }
            }),
            catchError((err: any): Observable<any> => {
                if (err instanceof HttpErrorResponse) {
                    switch ((<HttpErrorResponse>err).status) {
                        case 400:
                            return this.handle400Error(err);
                        case 401:
                            return this.handle400Error(err);
                        default:
                            const error = err.error;
                            if (error.messageCode !== null && error.messageCode !== '' && error.messageCode !== undefined) {
                                return throwError(error.messageCode.toString());
                            } else {
                                return throwError(err);
                            }
                    }
                } else {
                    const error = err.error;
                    if (error.messageCode !== null && error.messageCode !== '' && error.messageCode !== undefined) {
                        return throwError(error.messageCode.toString());
                    } else {
                        return throwError(err);
                    }
                }
            })
        );
    }

    handle400Error(error) {
        if (error && error.status === 400) {
            // If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
            return this.logoutUser(error);
        }
        if (error && error.status === 401) {
            // If we get a 401 and the error message is 'UNAUTHORIZED', the token is no longer valid so logout.
            return this.logoutUser(error);
        }
        return throwError(error.status.toString());
    }

    logoutUser(error) {
        this.authService.logout();
        return throwError(error);
    }

    addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
        // Adding token in request header if token is available
        if (token) {
            return req.clone({ setHeaders: { Authorization: 'Bearer ' + token } });
        } else {
            return req;
        }
    }
}
